import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getStatus } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiUrls } from "@/store/api/constants";

export default function useOnActions() {
  const [isAlertDialog, setIsAlertDialog] = useState(false);

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const state = useSelector((store) => store);
  const [currentRowId, setCurrentRowId] = useState(null);



  const deleteMenuListMasterStatus = getStatus(state, apiKeys.deleteMenuListMaster, '');

  const onCloseAlert = useCallback(() => {
    setIsAlertDialog((prevState) => !prevState);
    setCurrentRowId(null);
  }, []);

  const onAgreeAlert = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.deleteMenuListMaster(currentRowId),
      method: apiMethods.DELETE,
      key: apiKeys.deleteMenuListMaster,
      successMsg: formatMessage({ id: "menulist-master-has-been-deleted-successfully" }),
      failureMsg: formatMessage({ id: "failed-to-delete-menulist-master" }),
    }))
    onCloseAlert();
  }, [dispatch, formatMessage, onCloseAlert, currentRowId]);


  const onRowDelete = useCallback((id) => {
    setCurrentRowId(id);
    setIsAlertDialog(true);
  }, []);



  useEffect(() => () => {
    dispatch(clearData({ key: apiKeys.deleteMenuListMaster }));
  }, [dispatch]);


  return useMemo(() => ({
    onRowDelete,
    deleteMenuListMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,

  }), [
    onRowDelete,
    deleteMenuListMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,
  ])
}
